import React from 'react';

const PlanCard = ({ plan, selected, onSelect }) => {
  return (
    <div
      className={`card shadow-sm p-3 h-100 ${selected ? 'border-primary' : ''}`}
      onClick={() => onSelect(plan.pointPlanID)}
      style={{ cursor: 'pointer', borderRadius: '12px' }}
    >
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">₹{plan.price}</h5>
        <strong>{plan.points} Points</strong>
      </div>
      <div className="text-muted small mb-2">
        (Validity: {plan.validity} {plan.duration})
      </div>
      {plan.bonus > 0 && (
        <div className="text-success fw-semibold">+{plan.bonus}% bonus</div>
      )}
      <div className="form-check mt-3 text-end">
        <input
          className="form-check-input"
          type="radio"
          checked={selected}
          onChange={() => onSelect(plan.pointPlanID)}
        />
      </div>
    </div>
  );
};

export default PlanCard;
